import type { DateRange } from 'react-day-picker'

import { SpendingCustomerListDialog } from '@/modules/tracking/new-subscriber-analysis/ui/dialog/spending-customer-list.tsx'
import { PaginationProvider } from '@/utils/pagination/pagination-context.tsx'

const SpendingLowCustomerListDialogTexts = {
  title: 'Low-Spending Customer List',
  description:
    'In this List you can see all the new Low-Spending Customers within your set timeframe and maximum spend. You can create a list or view the Low-Spending Customers individually.',
}

interface Props {
  isOpen: boolean
  onClose: () => void
  creatorId: number
  limit: number
  date: DateRange
}
export const LowSpendingCustomerList = ({
  isOpen,
  onClose,
  creatorId,
  limit,
  date,
}: Props) => {
  return (
    <PaginationProvider>
      <SpendingCustomerListDialog
        title={SpendingLowCustomerListDialogTexts.title}
        description={SpendingLowCustomerListDialogTexts.description}
        isOpen={isOpen}
        onClose={onClose}
        creatorId={creatorId!}
        spendLimit={limit}
        high={false}
        date={date}
      />
    </PaginationProvider>
  )
}
